import React, { useEffect, useState } from 'react';
import { InputNumber, Select } from 'antd';
import documentService from '../../../services/documentService';

const DEFAULT_CURRENCY = 'ZAR';

/**
 * Currency amount with its own currency selector.
 */
const CurrencyField = ({ value, onChange, disabled = false, placeholder }) => {
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    let cancelled = false;

    documentService
      .getCurrencies()
      .then((items) => {
        if (!cancelled) setCurrencies(items);
      })
      .catch((error) => {
        console.warn('Failed to load currencies', error);
        if (!cancelled) setCurrencies([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const currency = value?.currency ?? DEFAULT_CURRENCY;
  const amount = value?.value ?? null;

  const options = currencies.length
    ? currencies.map((entry) => ({
        value: entry.currencyCode,
        label: `${entry.currencyCode} - ${entry.currencyName} (${entry.currencySymbol})`,
      }))
    : [{ value: DEFAULT_CURRENCY, label: DEFAULT_CURRENCY }];

  return (
    <div className="currency-field">
      <Select
        className="currency-field__currency"
        value={currency}
        options={options}
        disabled={disabled}
        onChange={(nextCurrency) => onChange?.({ currency: nextCurrency, value: amount })}
      />
      <InputNumber
        className="currency-field__amount"
        style={{ width: '100%' }}
        value={amount}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(nextValue) =>
          onChange?.({ currency, value: nextValue === null ? null : Number(nextValue) })
        }
      />
    </div>
  );
};

export default CurrencyField;
